import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  
  .header {
    display: flex;
    justify-content: space-between;
    .wrapper {
      display: flex;
      gap: 10px;
    }
  }

  .widgets-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;

export default { Wrapper, Row };
